var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageDefaultFallback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 639,
    height: 253,
    viewBox: "0 0 639 253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 639,
    height: 253,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M639.483,1282.568l-327-327a96,96,0,0,1,0-135.765L485.2,647.077q-11.1,6.58-23.05,12.165c-130.416,60.814-285.439,4.39-346.253-126.026L53.811,400.064C-7,269.648,49.421,114.625,179.837,53.811s285.439-4.39,346.253,126.026l62.089,133.152c44.872,96.228,25.909,205.861-39.5,281.153a96.027,96.027,0,0,1,104.227,21l110.91,110.91A93.942,93.942,0,0,1,827.65,619.315c-95.221-5.8-170.659-84.861-170.659-181.54a181.9,181.9,0,0,1,336.977-95.054l50-2.5v97.547l-33.244,59.725A182.17,182.17,0,0,1,872.938,616.47,93.831,93.831,0,0,1,949.8,706.827l3.609-20.465a80.857,80.857,0,0,1,159.257,28.081l-8.5,48.189A80.859,80.859,0,0,1,944,741.33a93.948,93.948,0,0,1-105.289,59.622L979.906,942.145a96,96,0,0,1,0,135.764L775.247,1282.568a96,96,0,0,1-135.764,0Z",
    transform: "translate(0 0)",
    fill: "#ffd5b9",
    opacity: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment-fallback-image",
    transform: "translate(-10386 -9888)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 639,
    height: 253,
    transform: "translate(10386 9888)",
    fill: "#ffe5d3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_13",
    "data-name": "Mask Group 13",
    transform: "translate(10386 9888)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(-397.187 -469.417)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Centili_device-05",
    "data-name": "Centili device-05",
    width: 654.571,
    height: 654.571,
    transform: "translate(393.249 360.434)",
    fill: "#ffd5b9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefaultFallback);
export default __webpack_public_path__ + "static/media/imageDefaultFallback.5fb932c748c01306b60b15af535f7609.svg";
export { ForwardRef as ReactComponent };